import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { experimentIdSelector, splitTrafficIdSelector } from 'ctm-selectors';

const withAbTesting = (splitTrafficId, experimentId) => (Component) => {
    class WithState extends React.PureComponent {

        render() {
            const { splitTrafficIdFromState, experimentIdFromState, ...rest } = this.props;
            return <Component {...rest} enabledAbTesting={!!(splitTrafficId === splitTrafficIdFromState || experimentId === experimentIdFromState)} />;
        }

    }

    WithState.propTypes = {
        splitTrafficIdFromState: PropTypes.string,
        experimentIdFromState: PropTypes.string
    };

    return connect(mapStateToProps)(WithState);
};

// @See /packages/ctm-components/components/results/comparable_results/comparable_results.js
const mapStateToProps = (state) => {
    const splitTrafficIdFromState = splitTrafficIdSelector(state);
    const experimentIdFromState = experimentIdSelector(state);
    return {
        splitTrafficIdFromState,
        experimentIdFromState
    };
};

export { withAbTesting };
